import script from "./ContactList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactList.vue?vue&type=script&setup=true&lang=js"

import "./ContactList.vue?vue&type=style&index=0&id=1ab3067f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab3067f"]])

export default __exports__